import "./assets/common.scss";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import OptionsLayout from "./container/OptionsLayout";

function App() {
  return (
    <Provider store={store}>
      <OptionsLayout />
    </Provider>
  );
}

export default App;
